"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireDefault(require("react"));

var _EditableContext = _interopRequireDefault(require("./EditableContext"));

const EditableRow = ({
  index,
  ...props
}) => {
  const [form] = _form.default.useForm();

  return /*#__PURE__*/_react.default.createElement(_form.default, {
    form: form,
    component: false
  }, /*#__PURE__*/_react.default.createElement(_EditableContext.default.Provider, {
    value: form
  }, /*#__PURE__*/_react.default.createElement("tr", Object.assign({}, props))));
};

var _default = EditableRow;
exports.default = _default;